/**
 * Génère un tableau de numéros de page pour la pagination, avec des points de suspension.
 * @param {number} currentPage - La page courante.
 * @param {number} totalPages - Le nombre total de pages.
 * @param {number} [maxPages=7] - Le nombre maximum de pages à afficher (par défaut : 7).
 * @returns {Array<number | string>} - Un tableau contenant les numéros de page et les points de suspension.
 */
export function getPaginationNumbers(currentPage, totalPages, maxPages = 7) {
    const pageNumbers = [];
    const ellipsis = '...';
  
    if (totalPages <= maxPages) {
      // Moins de maxPages pages : on affiche tout
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
      return pageNumbers.length === 0 ? [1] : pageNumbers;
    }
  
    const sidePages = 2; // Nombre de pages à afficher avant/après la page courante (hors début/fin)
  
    // Début du tableau
    if (currentPage <= sidePages + 1) {
      // Exemple : 1 2 3 4 5 ... 10
      for (let i = 1; i <= maxPages - 2; i++) {
        pageNumbers.push(i);
      }
      pageNumbers.push(ellipsis);
      pageNumbers.push(totalPages);
      return pageNumbers.length === 0 ? [1] : pageNumbers;
    }
  
    // Fin du tableau
    if (currentPage >= totalPages - sidePages) {
      // Exemple : 1 ... 6 7 8 9 10
      pageNumbers.push(1);
      pageNumbers.push(ellipsis);
      for (let i = totalPages - (maxPages - 3); i <= totalPages; i++) {
        pageNumbers.push(i);
      }
      return pageNumbers.length === 0 ? [1] : pageNumbers;
    }
  
    // Milieu du tableau
    // Exemple : 1 ... 5 6 7 ... 10
    pageNumbers.push(1);
    pageNumbers.push(ellipsis);
    for (let i = currentPage - 1; i <= currentPage + 1; i++) {
      pageNumbers.push(i);
    }
    pageNumbers.push(ellipsis);
    pageNumbers.push(totalPages);
  
    return pageNumbers.length === 0 ? [1] : pageNumbers;
  }
  